import { lazy } from "react";
import { FunctionComponent } from "react";
import {
  BarChart2,
  Book,
  Briefcase,
  CornerUpLeft,
  CreditCard,
  DollarSign,
  FileText,
  // Gift,
  Grid,
  Icon,
  Layers,
  Pocket,
  Shield,
  ShoppingBag,
  ShoppingCart,
  Shuffle,
  Smartphone,
  Trash2,
  Truck,
  UserCheck,
  Users,
} from "react-feather";
import { GET_ALL_FILTERED_RETURN_SALES_IS_DEFECTIVE, GET_RETURN_SALES_IS_DEFECTIVE } from "./../pages/returnSales/queries";

const Dashboard2 = lazy(() => import("../pages/dashboard2"));
const Money = lazy(() => import("../pages/money"));
const MoneyReceipts = lazy(() => import("../pages/moneyReceipts"));
const wMoney = lazy(() => import("../pages/returnMoney"));
const Purchase = lazy(() => import("../pages/purchases"));
const Reports = lazy(() => import("../pages/reports"));
const Sale = lazy(() => import("../pages/sales"));
const SaleStorage = lazy(() => import("../pages/SaleStorage"));
const Logistics = lazy(() => import("../pages/logistics"));
const purchasesStorage = lazy(() => import("../pages/purchasesStorage"));
const Counterparties = lazy(() => import("../pages/counterparties"));
const Products = lazy(() => import("../pages/products"));
const Residues = lazy(() => import("../pages/residues"));
const Warehouses = lazy(() => import("../pages/warehouses"));
const Factories = lazy(() => import("../pages/factories"));
const Showcases = lazy(() => import("../pages/showcases"));
const Managers = lazy(() => import("../pages/managers"));
const Trash = lazy(() => import("../pages/trash"));
const AuditLogs = lazy(() => import("../pages/auditLogs"));
const ReturnSales = lazy(() => import("../pages/returnSales"));
const ReturnPurchases = lazy(() => import("../pages/returnPurchases"))
const Roles = lazy(() => import("../pages/roles"))
const Subscription = lazy(() => import("../pages/subscription"))
const Tenants = lazy(() => import("../pages/tenants"))

const MobileSettings = lazy(() => import("../pages/mobileSettings"));

export function ReturnSalesIsDefective() {
  return (
    <ReturnSales
      isDefective
      hasPhoto
      pageName="returnSalesIsDefective"
      exportQuery={GET_ALL_FILTERED_RETURN_SALES_IS_DEFECTIVE}
      isDefectiveQuery={GET_RETURN_SALES_IS_DEFECTIVE}
    />
  );
}

export interface MenuItem {
  icon: Icon;
  component?: FunctionComponent<any>; //TODO add components
  title: string;
  seoTitle: string;
  route: string;
  link?: string | "";
}
const menuItems: MenuItem[] = [
  {
    /*
      BOSH PANEL.

      Ilgari ikkita bosh panel bor edi: eskisi "/" da, yangisi
      "/dashboard2" da. Guruh qarori bo'yicha eskisi olib tashlandi va
      yangisi asosiy sahifa bo'ldi — nomidagi "2" ham keraksiz qoldi.

      Manzil "/" ga ko'chdi. Eski "/dashboard2" havolasi ishlashda
      davom etadi (router ichida bosh sahifaga yo'naltiriladi), chunki
      odamlarda saqlab qo'yilgan havolalar bo'lishi mumkin.

      Eski sahifaning fayllari o'chirilmadi: undagi Card komponentidan
      boshqa joyda ham foydalanilyapti.
    */
    icon: Grid,
    component: Dashboard2,
    title: "dashboard2",
    seoTitle: "dashboard2",
    route: "/",
  },
  {
    icon: Pocket,
    component: Sale,
    title: "sale",
    seoTitle: "sale",
    route: "/sales",
  },
  {
    icon: Pocket,
    component: SaleStorage,
    title: "wSales",
    seoTitle: "wSales",
    route: "/wSales",
  },
  {
    icon: Truck,
    component: Logistics,
    title: "logistics",
    seoTitle: "logistics",
    route: "/logistics",
  },
  // {
  //   icon: Pocket,
  //   component: Sale,
  //   title: "sale",
  //   seoTitle: "sale",
  //   route: "/sales",
  // },
  {
    icon: ShoppingBag,
    component: Purchase,
    title: "purchase",
    seoTitle: "purchase",
    route: "/purchases",
  },
  {
    icon: ShoppingBag,
    component: purchasesStorage,
    title: "wPurchases",
    seoTitle: "wPurchases",
    route: "/wPurchases",
  },
  {
    icon: CornerUpLeft,
    title: "returnSale",
    seoTitle: "returnSale",
    route: "/returnSales",
    component: ReturnSales,
  },
  {
    icon: CornerUpLeft,
    title: "returnPurchase",
    seoTitle: "returnPurchase",
    route: "/returnPurchases",
    component: ReturnPurchases,
  },
  {
    icon: Shuffle,
    title: "defects",
    seoTitle: "defects",
    route: "/defects",
    component: ReturnSalesIsDefective,
  },
  // {
  //   icon: Gift,
  //   title: "Скидки",
  //   seoTitle: "Скидки",
  //   component: Discounts,
  //   route: "/discounts",
  // },
  {
    icon: Grid,
    title: "goods",
    seoTitle: "goods",
    component: Products,
    route: "/products",
  },
  // {
  //   icon: Percent,
  //   title: "discounts",
  //   seoTitle: "discounts",
  //   component: DiscountedProducts,
  //   route: "/discountedProducts",
  // },
  {
    icon: ShoppingCart,
    title: "residues",
    seoTitle: "residues",
    route: "/residues",
    component: Residues,
  },
  {
    icon: DollarSign,
    component: Money,
    title: "money",
    seoTitle: "money",
    route: "/moneys",
  },
  {
    icon: DollarSign,
    component: MoneyReceipts,
    title: "moneyReceipts",
    seoTitle: "moneyReceipts",
    route: "/moneyReceipts",
  },
   {
    icon: DollarSign,
    component: wMoney,
    title: "wMoney",
    seoTitle: "wMoney",
    route: "/wmoneys",
  },
  {
    icon: Users,
    title: "counterparties",
    seoTitle: "counterparties",
    route: "/counterparties",
    component: Counterparties,
  },
  {
    icon: Layers,
    component: Warehouses,
    title: "warehouses",
    seoTitle: "warehouses",
    route: "/warehouses",
  },
  {
    icon: Book,
    title: "showcases",
    seoTitle: "showcases",
    route: "/showcases",
    component: Showcases,
  },
  {
    icon: BarChart2,
    title: "factories",
    seoTitle: "factories",
    route: "/factories",
    component: Factories,
  },


  {
    icon: UserCheck,
    title: "managers",
    seoTitle: "managers",
    route: "/managers",
    component: Managers,
  },
  {
    // Rollar va huquqlar: har bir rol uchun menyu/ko'rish/qo'shish/
    // tahrirlash/o'chirish alohida belgilanadi
    icon: Shield,
    title: "roles",
    seoTitle: "roles",
    route: "/roles",
    component: Roles,
  },
  {
    // Korxonalar — platformaning eng yuqori sahifasi: mijoz korxonalar,
    // ularning muddati va kalitlari. Faqat tizim EGASIGA ko'rinadi,
    // korxona adminiga emas (hasPermission da alohida tekshiriladi).
    icon: Briefcase,
    title: "tenants",
    seoTitle: "tenants",
    route: "/tenants",
    component: Tenants,
  },
  {
    // Obuna: tizimdan foydalanish uchun to'lov va muddat nazorati
    icon: CreditCard,
    title: "subscription",
    seoTitle: "subscription",
    route: "/subscription",
    component: Subscription,
  },
  {
    // Mobil ilovada qaysi bo'lim va ustunlar ko'rinishini boshqarish
    icon: Smartphone,
    title: "mobileSettings",
    seoTitle: "mobileSettings",
    route: "/mobileSettings",
    component: MobileSettings,
  },
  // {
  //   icon: Tool,
  //   title: "Контроль",
  //   seoTitle: "Контроль",
  //   component: Control,
  //   route: "/control",
  // },
  {
    icon: FileText,
    component: Reports,
    title: "reports",
    seoTitle: "reports",
    route: "/reports/:name?",
    link: "/reports",
  },
  {
    icon: FileText,
    title: "auditLogs",
    seoTitle: "auditLogs",
    route: "/auditLogs",
    component: AuditLogs,
  },
  {
    icon: Trash2,
    title: "trash",
    seoTitle: "trash",
    route: "/trash",
    component: Trash,
  },

];

export default menuItems;
